import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from './../../app.config';
import { ExcelPreferences } from './user-excel-preferences.service';

@Injectable()
export class ExcelPreferencesClient {
  constructor(private _client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig) {
    this._endpoint = `${config.apiEndpointV2}/excel-preferences`;
  }

  private readonly _endpoint: string;

  create(pref: ExcelPreferences): Observable<any> {
    return this._client.post(`${this._endpoint}/`, JSON.stringify(pref));
  }

  get(context: string): Observable<any> {
    return this._client.get(`${this._endpoint}/`, { params: { context } });
  }

  update(pref: ExcelPreferences): Observable<any> {
    return this._client.put(`${this._endpoint}/`, JSON.stringify(pref));
  }
}
